import { render, staticRenderFns } from "./RebuttalUserAdminModal.vue?vue&type=template&id=207d3b40&"
import script from "./RebuttalUserAdminModal.vue?vue&type=script&lang=js&"
export * from "./RebuttalUserAdminModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports